import { useQuery } from "@tanstack/react-query"

import { useQueries } from "@/hooks/useRootContext.ts"

import type { GitHubAccountInfo } from "@/lib/client/generated/TypeDefinitions.ts"

export const hasLinkedGitHubAccountQueryKey = ["hasLinkedGitHubAccount"]
const authorizedGitHubAccountsQueryKey = ["authorizedGitHubAccounts"]

export function useGitHubProfile() {
  const client = useQueries().apiClient

  const isLinkedQuery = useQuery({
    queryKey: hasLinkedGitHubAccountQueryKey,
    queryFn: () => client.hasLinkedGitHubAccount(),
  })

  const accountsQuery = useQuery({
    queryKey: authorizedGitHubAccountsQueryKey,
    queryFn: () => client.listAuthorizedGitHubAccounts(),
    enabled: isLinkedQuery.data === true,
    staleTime: 5 * 60 * 1000 // 5 minutes, doesn't change often
  })

  const userAccount = accountsQuery.data?.find(
    (account: GitHubAccountInfo) => account.accountType === "User"
  )

  return {
    isConnected: isLinkedQuery.data ?? null,
    isCheckingConnection: isLinkedQuery.isLoading,
    isLoadingAccounts: accountsQuery.isLoading,
    accounts: accountsQuery.data ?? [],
    userAccount,
  }
}

